import { render } from "./DynamicIndicator.vue?vue&type=template&id=4d18807c&scoped=true&ts=true"
import script from "./DynamicIndicator.vue?vue&type=script&lang=ts"
export * from "./DynamicIndicator.vue?vue&type=script&lang=ts"

import "./DynamicIndicator.vue?vue&type=style&index=0&id=4d18807c&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d18807c"]])

export default __exports__